webpackJsonp([173304288045280],{

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.CaliforniaImageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(12);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _HeroSmall = __webpack_require__(8);
	
	var _HeroSmall2 = _interopRequireDefault(_HeroSmall);
	
	var _LocationMicroNav = __webpack_require__(10);
	
	var _LocationMicroNav2 = _interopRequireDefault(_LocationMicroNav);
	
	var _LocationContent = __webpack_require__(9);
	
	var _LocationContent2 = _interopRequireDefault(_LocationContent);
	
	var _LocationRelated = __webpack_require__(11);
	
	var _LocationRelated2 = _interopRequireDefault(_LocationRelated);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CaliforniaLocation = function (_React$Component) {
	  _inherits(CaliforniaLocation, _React$Component);
	
	  function CaliforniaLocation() {
	    _classCallCheck(this, CaliforniaLocation);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  CaliforniaLocation.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_HeroSmall2.default, { location: 'California' }),
	      _react2.default.createElement(_LocationMicroNav2.default, null),
	      _react2.default.createElement(_LocationContent2.default, {
	        category: 'PlacesForBikes',
	        title: 'Retail Revamp',
	        story: ' In late October, Walmart took a positive step to support bicycling by building on-street bike infrastructure in front of their San Leandro, California store as part of a remodel. PeopleForBikes advised on the project and the retail giant worked closely with local advocacy group Bike East Bay and city transportation staff on the improvements. "San Leandro has a vibrant cycling community and advocacy leader in Bike East Bay," said PeopleForBikes Vice President of Business Network Jenn Dice. "This bike lane is an important step to integrate bicycling into Walmart customers\u2019 lifestyles and to encourage store associates to bike to work. Our hope is that the San Leandro store inspires other retailers to incorporate bike lanes into development plans."'
	      }),
	      _react2.default.createElement(_gatsbyImage2.default, {
	        title: 'California 1-1',
	        alt: 'San Leandro, CA Wal-mart bike lane build',
	        sizes: this.props.data.californiaOneOneImage.sizes
	      }),
	      _react2.default.createElement(_LocationContent2.default, {
	        category: 'Research',
	        title: 'Just Kidding',
	        story: 'Specialized Foundation Ride for Focus Summit at Stanford University: This was the first of what Specialized expects to be an annual conference on the topic of the positive effects of bicycling on today\u2019s youth. Attendees at the summit included teachers from participating schools, academics working on the link between exercise/bike riding and attention/performance, and stakeholders from Specialized. We presented data from the PeopleForBikes U.S. Bicycle Participation study.'
	      }),
	      _react2.default.createElement(_gatsbyImage2.default, {
	        title: 'California 2-1',
	        alt: 'Specialized Foundation Ride for Focus Summit at Stanford University (Palo Alto)',
	        sizes: this.props.data.californiaTwoOneImage.sizes
	      }),
	      _react2.default.createElement(_LocationContent2.default, {
	        category: 'Govt\u2014State + Local',
	        title: 'California Dreamin\'',
	        story: 'We organized meetings with state legislators in coordination with other outdoor industry leaders to advance legislation that would create a new office of outdoor industry in California. This included meeting with the California Air Resources Board, CalSTA, the Assembly Budget Chair, the Governor\'s Office and Senator Fran Pavley\'s Office.'
	      }),
	      _react2.default.createElement(_gatsbyImage2.default, {
	        title: 'California 3-1',
	        alt: 'California State Meetings',
	        sizes: this.props.data.californiaThreeOneImage.sizes
	      }),
	      _react2.default.createElement(_LocationRelated2.default, {
	        prevLocationName: 'Providence, RI',
	        prevLocationPath: 'providence',
	        prevLocationImgPath: this.props.data.californiaPrevImage,
	        nextLocationName: 'Columbus, OH',
	        nextLocationPath: 'columbus',
	        nextLocationImgPath: this.props.data.californiaNextImage
	      })
	    );
	  };
	
	  return CaliforniaLocation;
	}(_react2.default.Component);
	
	exports.default = CaliforniaLocation;
	
	// GraphQL queries for each image, got to be a better way to do this but whatever for now
	
	var CaliforniaImageQuery = exports.CaliforniaImageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-california-js-ed003b3b49804a0fcec2.js